import httpClient from '@/libs/http-client'

export function getList (aid) {
  const url = `/ab/get_list/${aid}`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function addPage (values) {
  const url = `/ab/add_page`
  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function modifyPage (values) {
  const url = `/ab/modify_page`

  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function deletePage (values) {
  const url = `/ab/delete_page`

  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}
